import React from "react";
import "./Portfolio.css";
function Portfolio() {
	return <h1>Coming Soon!</h1>;
}

export default Portfolio;
